import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormControl } from '@angular/forms';
import { DropDownModel } from '@app/pages/customer/models/dropdown.model';

@Component({
    selector: 'ngx-select',
    styleUrls: ['./select.component.scss'],
    templateUrl: './select.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class SelectComponent {
  @Input() control: FormControl;
  @Input() list: Array<DropDownModel>[];

  @Input() placeholder: string = 'Please select';
  @Input() disabled: boolean = false;

  @Input() value: string = 'value';
  @Input() display: string = 'display';
  @Input() hiddenItem: boolean = false;

  @Output() selectedChange = new EventEmitter<any>();

  onSelectedChange(value) {
    this.selectedChange.next(value);
  }
}
